import { cloneDeep } from 'lodash-es';
import type { Store } from 'pinia';

/** Usage: storeName.$reset(); */
export function resetStore({ store }: { store: Store }) {
  const initialState = cloneDeep(store.$state);
  store.$reset = () => {
    store.$patch(cloneDeep(initialState));
  };
}
